module.exports = __webpack_public_path__ + "img/DSC_0786.246db386.jpeg";